import React from 'react';
import mime from 'mime-types';
import { Modal, Input, Icon, Button } from 'semantic-ui-react';

class FileUploadModal extends React.Component {

  // Initial State
  state = {
    file: null, 
    authorized: ['image/jpeg', 'image/png']
  };

  // Sets the file state if file gets uploaded
  addFile = event => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ file });
    }
  };

  // Sends the added file
  sendFile = () => {
    const { file } = this.state;
    const {uploadFile, closeModal} = this.props;

    if (file !== null) {
      if (this.isAuthorized(file.name)) {
        const metadata = { contentType: mime.lookup(file.name) };
        uploadFile(file, metadata)
        closeModal();
        this.clearFile();
      }
    }
  };

  // Uses mime types to lookup file type and authorize it (.jpg and .png)
  isAuthorized = filename => this.state.authorized.includes(mime.lookup(filename));

  // Clears uploaded file
  clearFile = () => this.setState({ file: null });

  // Semantic UI's Modal view that appears when someone clicks on "Send Image"
  render() {

    const { modal, closeModal } = this.props;

    return (
      <Modal basic open={modal} onClose={closeModal}>
        <Modal.Header> Select Image File to Upload </Modal.Header>
        <Modal.Content>
          <Input onChange={this.addFile} fluid label='File types: jpg, png'
            name='file'
            type='file'
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.sendFile} color='green' inverted >
            <Icon name='checkmark'/> Send
          </Button>
          <Button color='red' inverted onClick={closeModal}>
            <Icon name='remove'/> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default FileUploadModal;